export const UPDATE_LOADING_COMPANY = 'UPDATE_LOADING_COMPANY';
export const UPDATE_ERROR_COMPANY = 'UPDATE_ERROR_COMPANY';
export const UPDATE_COMPANY = 'UPDATE_COMPANY';